import { defineStore } from 'pinia';
import { ref, reactive } from 'vue';
import { LoginScenarioState, SecretNumberState } from '@vrp/js/types';
import { Queue } from './js/queue';
import eventBus from '@vrp/js/eventBus'; // eventBus.js 파일 가져오기

export const useStore = defineStore({
	id: 'vrp_store',
	state: () => ({
		build_version: '20241010',
		cur_location: ref({
			latitude: 37.4082411,
			longitude: 127.1000862,
		}),
		is_triggered_history_back_by_develover: ref(true),
		modal_state: reactive({
			login_modal_state: LoginScenarioState.None,
			terms_text_modal_state: false,
			route_plan_select_end_point_modal_state: false,
			route_plan_list_detail_show_state: false,
			fix_route_plan_list_detail_show_state: false,
			route_plan_opt_complete_list_detail_show_state: false,
			route_plan_opt_complete_change_opt_option_modal_state: false,
			route_history_list_detail_show_state: false,
			//alert 모달 상태가 꼬여서 세분화
			common_loading_send_route: false,
			common_alert_modal_state: false,
			common_alert_modal_state_VrpRoutePlanSection: false,
			common_alert_modal_state_VrpRoutePlanSection_noStopOver: false,
			common_alert_modal_state_VrpRoutePlanSection_warning: false,
			common_alert_modal_state_VrpRoutePlanOptOptionSection: false,
			common_alert_modal_state_VrpRoutePlanOptCompleteSection: false,
			common_alert_modal_state_VrpExcelSelectHeaderDetail: false,
			//사용이 확인된 state
			search_addr_modal_state: false,
			loadingModal: {
				common_loading_send_route: false,
				opt_loading_modal_state: false,
				opt_loading_modal_state_reOpt: false,
			},
			alertModal: {
				noDriverAlertModalState: false,
				excelModal_failAlertModalState: false,
				excelSelectAddr_cancelAlertModalState: false,
				excelSelectHeaderDetail_failAlertModalState: false,
			},
			routePlanModal: {
				isFromDirect: false,
				vrpHeadExist: false,
				vrpExcelUploadModalState: false,
				vrpSelectFromHistoryModal: false,
				vrpExcelSelectSheetModalState: false,
				vrpExcelSelectAddrModalState: false,
				vrpExcelSelectHeadModalState: false,
				vrpExcelSelectHeadDetailModalState: false,
			},
			fixRoutePlanModal: {
				isFromFixDirect: false,
				vrpFixHeadExist: false,
				vrpFixExcelUploadModalState: false,
				vrpFixSelectFromHistoryModal: false,
				vrpFixExcelSelectSheetModalState: false,
				vrpFixExcelSelectAddrModalState: false,
				vrpFixExcelSelectHeadModalState: false,
				vrpFixExcelSelectHeadDetailModalState: false,
			},
			region: {
				isShowingAreaRegCancelPopup: false,
				isShowingAreaDeletePopup: false,
				isShowingRegionAddressSearchUi: false,
				isShowingNotDriverPopup: false,
			},
			driver: {
				isReMessageSuccessPopup: false,
				isReMessageFailPopup: false,
				isPhoneNumberConfirmPopup: false,
				isRejectDeleteDriverPopup: false,
			},
			account: {
				isShowinglogoutPopup: false,
				isShowingPassword: SecretNumberState.None,
				isShowingEmail: false,
				isShowingCorpAddress: false,
				isShowingMemberWithdraw: false,
			},
			dashboard: {
				isShowingPersonalInfoPolicy: true,
			},
		}),
		isDriversReload: false,
		memberInfo: ref(null),
	}),
	actions: {
		setModalState(modal_state) {
			this.modal_state = modal_state;
		},
		change_modal_state(modal_name, state) {
			this.modal_state[modal_name] = state;
		},
		changeModalState(modal_cat, modal_name, state) {
			if (!modal_cat) {
				// 루트 modal_state 직접 변경
				this.modal_state[modal_name] = state;
			} else {
				// 카테고리(modal_cat) 내부 변경
				if (!this.modal_state[modal_cat]) {
					this.modal_state[modal_cat] = {};
				}
				this.modal_state[modal_cat][modal_name] = state;
			}
		},
		changeRoutePlanPage(page) {
			this.route_plan_page = page;
		},
		setIsDriversReload(isDriversReload) {
			this.isDriversReload = isDriversReload;
		},
		setMemberInfo(memberInfo) {
			this.memberInfo = memberInfo;
		},
		showMessagePopup(message) {
			eventBus.emit('notification-popup:show', message);
		},
		showMessageToast(message) {
			eventBus.emit('notification-toast:show', message);
		},
		setCurLocation(cur_location) {
			this.cur_location = cur_location;
		},
	},
});
